import React, { useEffect, useState } from 'react'
import { Card, CardContent, makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import LineChart from 'src/components/common/charts/LineChart'

const CHART_HEIGHT = 223
const CHART_COLORS = [COLORS?.GREY]

const ClaimTrend = ({ portfolioData }) => {
  const classes = useStyles()
  const [ratios, setRatios] = useState([])
  const [allYears, setAllYears] = useState([])

  useEffect(() => {
    if (portfolioData) {
      if (portfolioData?.length !== 0) {
        let ratiosT = []
        let allYearsT = []
        portfolioData?.map((item) => {
          if (item?.claimsRatio !== null) {
            ratiosT?.push(item?.claimsRatio)
            allYearsT?.push(item?.year)
          }
        })
        setRatios(ratiosT)
        setAllYears(allYearsT)
      }
    }
  }, [portfolioData])

  return (
    <>
      <div className={classes.root}>
        <Card className={classes.cardContainer}>
          <CardContent className={classes.cardContentContainer}>
            <h2 className={classes.title}>Claim Trend</h2>
            <LineChart
              ratios={ratios}
              allYears={allYears}
              height={CHART_HEIGHT}
              colors={CHART_COLORS}
            />
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default ClaimTrend

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    textAlign: 'center',
  },
  cardContainer: {
    borderRadius: '10px',
  },
  cardContentContainer: {
    padding: '20px 0px 6px 0px',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    marginTop: '0px',
    color: COLORS.GREY,
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyItems: 'center',
    flexDirection: 'column',
    fontWeight: '600',
  },
  supportText: {
    marginTop: 0,
    fontSize: 17,
  },
  btnLabel: {
    textTransform: 'capitalize',
    color: COLORS.LINK_COLOR_DARK,
    textDecoration: 'underline',
    marginTop: '20px',
  },
  modalClass: {
    height: '90%',
    overflow: 'auto',
  },
})
